export default __webpack_public_path__ + "static/media/inf-avatar.e4f8cd16.png";